import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $isCompleted: boolean }>`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  height: 100%;
  min-height: 160px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.black3};
  background: ${({ theme }) => theme.colors.white};
  transition: all 0.3s ease;
  &:hover {
    background: ${({ theme }) => theme.colors.black1};
  }
  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    flex: 1 0 0;
    width: auto;
  }
  ${({ $isCompleted }) =>
    $isCompleted &&
    css`
      border-radius: 8px;
      border: 1px solid ${({ theme }) => theme.colors.black3};
      color: ${({ theme }) => theme.colors.black6};
    `}
`;

export const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Description = styled.div`
  flex: 1;
  overflow: hidden;
  color: ${({ theme }) => theme.colors.black7};
  text-overflow: ellipsis;

  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    -webkit-line-clamp: 3;
  }
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const PointsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2px;
`;
